'use client';

import { useEffect, useRef } from 'react';

/** Full transition duration; shortened drastically under reduced motion. */
const FLYOVER_MS = 1200;
const FLYOVER_REDUCED_MS = 150;

/**
 * Short CSS-only transition between goal-pick and the live session. No
 * animation-JS island — the warp effect is CSS keyframes on transform/opacity
 * only, matching the marketing Starfield's reduced-motion handling.
 */
export default function Flyover({ onDone }: { onDone: () => void }) {
  const doneRef = useRef(onDone);
  doneRef.current = onDone;

  useEffect(() => {
    const reducedMotion =
      typeof matchMedia === 'function' &&
      matchMedia('(prefers-reduced-motion: reduce)').matches;
    const timer = setTimeout(
      () => doneRef.current(),
      reducedMotion ? FLYOVER_REDUCED_MS : FLYOVER_MS,
    );
    return () => clearTimeout(timer);
  }, []);

  return (
    <button
      type="button"
      className="onboarding-flyover"
      onClick={() => doneRef.current()}
      aria-label="Skip to training"
    >
      <span className="onboarding-flyover-warp" aria-hidden="true" />
      <span className="onboarding-flyover-stars" aria-hidden="true" />
      <span className="onboarding-flyover-text">Launching…</span>
    </button>
  );
}
